export default __webpack_public_path__ + "static/media/four.f2714de7.png";